import request from "@/helper/request";


//获取小程序二维码
export function getUnlimitedQRCode(scene) {
  return request({
    url: "/api/miniProgram/getUnlimitedQRCode",
    method: "get",
    responseType: 'blob',
    params: {
      scene: scene
    }
  });
}


//web端轮询扫描二维码
export function checkSceneLoginStatus(scene) {
  return request({
    url: "/api/miniProgram/checkSceneLoginStatus",
    method: "get",
    params: {
      scene: scene
    }
  });
}

//获取大图
export function getBannerList() {
  return request({
    url: "/open/Jobhb/getBannerList",
    method: "get"
  });
}

//图片预览
export function getPreviewUrl(objectKey) {
  return request({
    url: "/open/Jobhb/getPreviewUrl",
    method: "get",
    params: {
      objectKey: objectKey
    }
  });
}

//获取公告
export function getCommentList() {
  return request({
    url: "/open/Jobhb/getCommentList",
    method: "get"
  });
}

//获取公告列表
export function getCommentListWithPage(data) {
  return request({
    url: "/open/Jobhb/getCommentListWithPage",
    method: "get",
    params: data
  });
}

//获取公告详情
export function getCommentById(cmCommentId) {
  return request({
    url: "/open/Jobhb/getCommentById",
    method: "get",
    params: {
      cmCommentId: cmCommentId
    }
  });
}


//招聘项目列表
export function getReRecruitProjectList() {
  return request({
    url: '/open/Jobhb/getReRecruitProjectList',
    method: 'get',
  })
}


//查询单个招聘项目
export function getSingleRecruitProject(reRecruitProjectId) {
  return request({
    url: '/api/miniProgram/getSingleRecruitProject',
    method: 'get',
    params: {
      reRecruitProjectId: reRecruitProjectId
    }
  })
}


//获取项目内公司列表
export function getProjectCompanyList(data) {
  return request({
    url: '/api/miniProgram/getProjectCompanyList',
    method: 'get',
    params: data
  })
}


//获取图形验证码
export function getCaptchaImage() {
  return request({
    url: "/open/Jobhb/captchaImage",
    method: 'get',
    timeout: 20000
  });
}


//发送验证码
export function sendCode(data) {
  return request({
    url: "/open/Jobhb/sendCode",
    method: "post",
    data
  });
}

//验证码登录
export function verifyCodeLogin(phoneNumber, verifyCode) {
  return request({
    url: "/open/Jobhb/verifyCodeLogin",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      verifyCode: verifyCode
    }
  });
}

//注册
export function register(phoneNumber, verifyCode, userPassword) {
  return request({
    url: "/open/Jobhb/register",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      verifyCode: verifyCode,
      userPassword: userPassword
    }
  });
}

//密码登录
export function passwordLogin(phoneNumber, userPassword) {
  return request({
    url: "/open/Jobhb/passwordLogin",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      userPassword: userPassword
    }
  });
}

//忘记密码
export function editPassword(phoneNumber, verifyCode, newPassword) {
  return request({
    url: "/open/Jobhb/editPassword",
    method: "post",
    params: {
      phoneNumber: phoneNumber,
      verifyCode: verifyCode,
      newPassword: newPassword
    }
  });
}


//最新岗位
export function getLatestPositionList() {
  return request({
    url: "/open/Jobhb/getLatestPositionList",
    method: "get",
    params: {
      size: "12"
    }
  });
}

//热门岗位
export function getHotPositionList() {
  return request({
    url: "/open/Jobhb/getHotPositionList",
    method: "get",
    params: {
      size: "12"
    }
  });
}

//热门单位
export function getHotCompanyList() {
  return request({
    url: "/open/Jobhb/getHotCompanyList",
    method: "get",
    params: {
      limit: "6"
    }
  });
}

//获取岗位列表
export function getJobsList(data) {
  return request({
    url: "/open/Jobhb/jobsList",
    method: "post",
    data: data
  });
}

//获取岗位详情
export function getJobs(jobId) {
  return request({
    url: "/open/Jobhb/jobs",
    method: "post",
    params: {
      jobId: jobId
    }
  });
}

// 查询岗位的残疾信息
export function getDisabledStatus(jobIds) {
  return request({
    url: '/api/miniProgram/getDisabledStatus/' + jobIds,
    method: 'delete'
  })
}

//获取公司信息详情
export function getCompany(companyId) {
  return request({
    url: "/api/company/company",
    method: "post",
    params: {
      companyId: companyId
    }
  });
}

//获取公司信息列表
export function getCompanyList(data) {
  return request({
    url: "/api/company/companyList",
    method: "post",
    params: data
  });
}

//获取推荐岗位
export function getRecomJobs(data) {
  return request({
    url: "/api/jobs/recomJobs",
    method: "post",
    data: data
  });
}

//获取岗位投递状态
export function getJobApplyStatus(jobId) {
  return request({
    url: "/api/miniProgram/getJobApplyStatus/" + jobId,
    method: "get"
  });
}

//投递岗位
export function applyForJob(jobId, reMiniProgramAttachmentList) {
  return request({
    url: "/api/miniProgram/applyForJob",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      jobId: jobId,
      reMiniProgramAttachmentList: reMiniProgramAttachmentList
    }
  });
}

//投递岗位信息列表
export function jobRelationList(data) {
  return request({
    url: "/api/miniProgram/jobRelationList",
    method: "post",
    params: data
  });
}

//个人信息回显
export function personalInfo() {
  return request({
    url: "/api/miniProgram/personalInfo",
    method: "get"
  });
}

//个人信息提交
export function personalInfoCommit(data) {
  return request({
    url: "/api/miniProgram/personalInfoCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}


//求职者信息提交
export function entryInfoCommit(data) {
  return request({
    url: "/api/miniProgram/entryInfoCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}

//工作经历提交
export function workExperienceCommit(data) {
  return request({
    url: "/api/miniProgram/workExperienceCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}


//全部地区
export function areaInfoList() {
  return request({
    url: '/api/miniProgram/getAreaInfo',
    method: 'get',
  })
}

//湖北地区
export function areaInfoHuBeiList() {
  return request({
    url: '/api/miniProgram/getAreaInfoHuBei',
    method: 'get',
  })
}

//行业
export function reTradeList() {
  return request({
    url: "/api/miniProgram/reTradeList",
    method: "get"
  });
}

//大学专业
export function undergraduateMajorList() {
  return request({
    url: "/api/miniProgram/undergraduateMajorList",
    method: "get"
  });
}

//教育经历提交
export function educationExperienceCommit(data) {
  return request({
    url: "/api/miniProgram/educationExperienceCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}

//项目经历提交
export function projectExperienceCommit(data) {
  return request({
    url: "/api/miniProgram/projectExperienceCommit",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
}

//工作经历删除
export function deleteWorkExperience(ids) {
  return request({
    url: "/api/miniProgram/deleteWorkExperience/" + ids,
    method: "delete"
  });
}

//教育经历删除
export function deleteEducationExperience(ids) {
  return request({
    url: "/api/miniProgram/deleteEducationExperience/" + ids,
    method: "delete"
  });
}

//项目经历删除
export function deleteProjectExperience(ids) {
  return request({
    url: "/api/miniProgram/deleteProjectExperience/" + ids,
    method: "delete"
  });
}

//上传简历
export function resumeUpload(resume) {
  return request({
    url: "/api/miniProgram/resumeUpload",
    method: "get",
    params: {
      resume: resume
    }
  });
}

// 简历下载
export function download(resume) {
  return request({
    url: "/api/miniProgram/download",
    method: "get",
    params: {
      resume: resume
    },
    responseType: "blob"
  });
}

//地域
export function getCmLocation() {
  return request({
    url: "/open/Jobhb/getCmLocation",
    method: "get"
  });
}


//通知列表
export function queryAccountReMessage(query) {
  return request({
    url: "/api/miniProgram/queryAccountReMessage",
    method: "get",
    params: query
  });
}


//通知删除
export function deleteWebMessage(reWebMessageIds) {
  return request({
    url: "/api/miniProgram/deleteWebMessage/" + reWebMessageIds,
    method: "DELETE"
  });
}


//通知批量设置为已读
export function setWebMessageReadStatus(reWebMessageIds) {
  return request({
    url: "/api/miniProgram/setWebMessageReadStatus/" + reWebMessageIds,
    method: "DELETE"
  });
}


//获取账号未读站内信数量
export function getSysMessageCount() {
  return request({
    url: "/api/miniProgram/getSysMessageCount",
    method: "get"
  });
}


//获取审核状态
export function openGetUser() {
  return request({
    url: '/api/miniProgram/openGetUser',
    method: 'get',
  })
}


//提交审核
export function setUserAuditStatusCommit() {
  return request({
    url: '/api/miniProgram/setUserAuditStatusCommit',
    method: 'get',
  })
}


//代办事项列表
export function getCheckResumeApplicationList(query) {
  return request({
    url: "/api/miniProgram/getCheckResumeApplicationList",
    method: "get",
    params: query
  });
}


//批量审核申请
export function setCheckResumeApplicationStatus(query) {
  return request({
    url: "/api/miniProgram/setCheckResumeApplicationStatus",
    method: "DELETE",
    params: query
  });
}


//获取代办事项数量
export function getCheckResumeApplicationUnHandleCount() {
  return request({
    url: "/api/miniProgram/getCheckResumeApplicationUnHandleCount",
    method: "get"
  });
}


//人工推荐岗位列表
export function manualRecommendationJobList(query) {
  return request({
    url: "/api/miniProgram/getManualRecommendationJobList",
    method: "get",
    params: query
  });
}


//岗位关注列表
export function getJobCollectList(query) {
  return request({
    url: '/api/miniProgram/getJobCollectList',
    method: 'get',
    params: query
  })
}


//公司关注列表
export function getCompanyCollectList(query) {
  return request({
    url: '/api/miniProgram/getCompanyCollectList',
    method: 'get',
    params: query
  })
}

//查询岗位是否关注
export function isJobCollected(jobId) {
	return request({
		url: '/api/miniProgram/isJobCollected',
		method: 'get',
		params: {
			jobId: jobId
		}
	})
}


//查询公司是否关注
export function isCompanyCollected(reCompanyId) {
	return request({
		url: '/api/miniProgram/isCompanyCollected',
		method: 'get',
		params: {
			reCompanyId: reCompanyId
		}
	})
}


//关注岗位
export function doJobCollect(reJobId) {
	return request({
		url: '/api/miniProgram/doJobCollect',
		method: 'get',
		params: {
			reJobId: reJobId
		}
	})
}


//关注公司
export function doCompanyCollect(reCompanyId) {
	return request({
		url: '/api/miniProgram/doCompanyCollect',
		method: 'get',
		params: {
			reCompanyId: reCompanyId
		}
	})
}




